var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useState, useCallback } from 'react';
export var useSearchLock = function (_a) {
    var searchContainer = _a.searchContainer, searchPlaceholder = _a.searchPlaceholder, setInputValue = _a.setInputValue;
    var _b = __read(useState(false), 2), isLocked = _b[0], setLocked = _b[1];
    var lockSearch = useCallback(function () {
        // Before "locked" animation kicks in, we will adjust element top
        // position for animation purposes. As the element has "static" position
        // applied on locked = false, this will not affect it in any way before
        // "entering" phase starts
        var rect = searchContainer.current.getBoundingClientRect();
        searchContainer.current.style.willChange = 'top, background-color';
        searchContainer.current.style.top = rect.top + "px";
        setLocked(true);
    }, [searchContainer]);
    var unlockSearch = useCallback(function () {
        // Before "unlocking" screen, we will adjust the top position
        // to the current placeholder position, so the form animates
        // back to the appropriate place
        var rect = searchPlaceholder.current.getBoundingClientRect();
        searchContainer.current.style.top = rect.top + "px";
        setLocked(false);
        setInputValue('');
        var active = document.activeElement;
        if (active) {
            active.blur();
        }
    }, [searchPlaceholder]);
    return {
        isLocked: isLocked,
        lockSearch: lockSearch,
        unlockSearch: unlockSearch,
    };
};
